export { default as getChannelPartners } from './getChannelPartners';
export { default as getChannelPartner } from './getChannelPartner';
